<template>
  <div>
    <img
        :src="require(`../../../assets/images/want-more@2x.png`)"
        :srcset="`${require(`../../../assets/images/want-more@1x.png`)} 1x, ${require(`../../../assets/images/want-more@2x.png`)} 2x, ${require(`../../../assets/images/want-more@3x.png`)} 3x, ${require(`../../../assets/images/want-more@4x.png`)} 4x`"
    />

    <div class="modal-body">
      <h2>{{ 'Batch Processing Locked' | trans }}</h2>
      <p>{{ 'You\'ve hit our concurrent image creation limit.' | trans }}</p>
      <p class="font-weight-bold">{{ "Consider upgrading to Premium for the ability to process more images simultaneously." | trans }}</p>
      <p>{{ "Thank you for your understanding!" | trans }}</p>
    </div>
  </div>
</template>
<script>
import store from '../../../mixins/store.mixin';

export default {
  name: 'MaxConcurrentLimitPro',
  props: {},
  components: {},
  mixins: [store],
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>
